module.exports = __webpack_public_path__ + "a60246042cb1d371ee7ff2459bae3579.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/webex_source_manager/assets/webex-logo-icon.svg
// module id = ./src/components/webex_source_manager/assets/webex-logo-icon.svg
// module chunks = index